exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card[data-v-64a293b5] {\n  max-width: 700px;\n  margin: 0 auto;\n}\n.error_message[data-v-64a293b5] {\n  color: red;\n}\n.el-form-item[data-v-64a293b5] .el-form-item__error {\n  position: static;\n}", ""]);

// exports
